import { Injectable } from '@angular/core';
import { CurrentUserService } from './user/current-user.service';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { DatepickerLocaleService } from './datepicker-locale.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly storageKey = 'selectedLanguage';
  private languageSubject = new BehaviorSubject<string>('');
  public language$ = this.languageSubject.asObservable();

  constructor(
    private currentUserService: CurrentUserService,
    private translate: TranslateService,
    private datepickerLocaleService: DatepickerLocaleService
  ) {
    const currentLang = this.getLanguage();
    if (currentLang) {
      this.languageSubject.next(currentLang);
      this.applyLanguage(currentLang);
    }

    this.datepickerLocaleService.currentLocale$.subscribe((locale) => {
      if (locale && locale !== this.languageSubject.value) {
        this.languageSubject.next(locale);
      }
    });
  }

  setLanguage(lang: string): void {
    localStorage.setItem(this.storageKey, lang);

    this.applyLanguage(lang);

    this.languageSubject.next(lang);
  }

  private applyLanguage(lang: string): void {
    this.translate.use(lang);

    this.datepickerLocaleService.setLocale(lang);
  }

  getLanguage(): string {
    const storedLang = localStorage.getItem(this.storageKey);
    if (storedLang) {
      return storedLang;
    }

    const currentUser = this.currentUserService.GetSession();
    if (currentUser && currentUser.selectedLanguageCode) {
      localStorage.setItem(this.storageKey, currentUser.selectedLanguageCode);
      return currentUser.selectedLanguageCode;
    }

    return 'tr';
  }
}
